module.exports = {
      id: "text-usage",
      viewBox: "0 0 18.361 15.287",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#text",
      toString: function () {
        return this.url;
      }
    }